export enum NotificationQueries {
	GET_MY_NOTIFICATIONS = `
    query MyNotifications($where: NotificationUserFilterInput, $first: Int, $after: String) {
        myNotifications(
            where: $where,
            first: $first,
            after: $after
        ) {
            totalCount
            nodes {
                id
                readDate
                notification {
                    id
                    title
                    description
                    detailUrl
                    date
                    entityType {
                        id
                        name
                    }
                    event {
                        id
                        name
                    }
                }
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                startCursor
                endCursor
            }
        }
    }
    `,
	GET_MY_UNREAD_NOTIFICATIONS = `
    query MyUnreadNotificationCount {
        myUnreadNotificationCount
    }
    `,
}
